import { render, staticRenderFns } from "./Production.vue?vue&type=template&id=67b0077a&scoped=true"
import script from "./Production.vue?vue&type=script&lang=ts"
export * from "./Production.vue?vue&type=script&lang=ts"
import style0 from "./Production.vue?vue&type=style&index=0&id=67b0077a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0077a",
  null
  
)

export default component.exports